import colors from '../_shared/colors';

export default {
  container: `
    background-color: ${colors.white};
  `,
  contentContainer: `
    background-color: ${colors.lightBackground};
    padding: 20px;
    overflow: auto;
    overflow-x: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
  `,
  searchContainer: `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    .ant-input-search {
      width: 100%;
    }
  `,
  pbStickyTop: `
    position: sticky;
    /* Layout.Content has padding:20px so the scroll viewport sits 20px below
       the outer edge.  margin-top + top of -20px pulls the bar up into that
       padding band — both in natural flow (margin) and when stuck (top) —
       so the spacing reads the same whether or not it's currently pinned. */
    top: -20px;
    z-index: 20;
    background-color: ${colors.white};
    margin: -20px -20px 10px -20px;
    padding: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  `,
};
